'use client';

import React from 'react';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';

type Props = {
  children: React.ReactNode;
  sidebar: React.ReactNode;
};

const CalendarLayout = ({ children, sidebar }: Props) => {
  return (
    <Stack direction={{ xs: 'column', md: 'row' }} spacing={{ xs: 0, md: 3 }} sx={{ mt: 2 }}>
      <Box sx={{ width: { md: 260 }, flexShrink: 0, mb: { xs: 1, md: 0 } }}>
        {sidebar}
      </Box>
      <Box sx={{ flexGrow: 1, minWidth: 0 }}>
        {children}
      </Box>
    </Stack>
  );
};

export default CalendarLayout;
